exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bindSizeGroupModal .ivu-modal{position:relative;max-width:1000px}", ""]);

// exports
